export default __webpack_public_path__ + "static/banner-ea99db0c591a7bb8006616d00ac86199.webp";